@import 'styles/variables';
@import 'styles/mixins';
@import 'styles/blaze/mixins';

.container {
  width: 100%;
  border-radius: 10px;
  background-color: var(--light-100);
  padding: 10px 15px 15px 15px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  box-shadow: 1px 1px 0px 0px #fff inset, 0px 8px 37px 0px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(25px);
  cursor: pointer;

  @include for-phone-only {
    box-shadow: 0px 6px 53px 0px rgba(0, 0, 0, 0.31);
  }

  transition: background-color 0.2s ease;

  &:hover {
    background: var(--light-40);
  }

  .header {
    display: flex;
    width: 100%;
    justify-content: space-between;
    position: relative;

    .iconContainer {
      position: absolute;
      top: -4px;
      right: -8px;
    }
  }
}
